import "./style.css";
import React, { useState, useEffect, useContext } from "react";
import InstagramIcon from "@mui/icons-material/Instagram";
import Logo from "../../../../resources/logo.png";
import { CartContext } from "../../../../context/CartContext";
import { host } from "../../../../config/Config";
import EducationBreadcrumb from "../../../../common/EducationBreadcrumb";

export const OneOnOne = () => {
    const phoneNumber = "+381 60-3859-426";
    const { addToCart } = useContext(CartContext);
    const [price, setPrice] = useState(0);
    const [loading, setLoading] = useState(true);
    const [fadeIn, setFadeIn] = useState(false);

    useEffect(() => {
        window.scrollTo(0, 0);

        // Trigger fade in after a brief delay
        setTimeout(() => {
            setFadeIn(true);
        }, 100);

        fetch(`${host}/api/v1/education-prices/type/one-on-one`)
            .then((response) => response.json())
            .then((data) => {
                setPrice(data.price);
                setLoading(false);
            })
            .catch((error) => {
                console.error("Error fetching price:", error);
                setPrice(50);
                setLoading(false);
            });
    }, []);

    const HandleOpenMap = () => {
        const url = `https://maps.app.goo.gl/6wxPp2i9rRZ45HQs6`;
        window.open(url, "_blank");
    };

    return (
        <div className='page-oneonone'>
            <EducationBreadcrumb />

            <div className={`items-oneonone ${fadeIn ? "fade-in" : ""}`}>
                <h1
                    style={{
                        fontSize: "37px",
                        color: "#be9455",
                        letterSpacing: "1px",
                        textShadow:
                            "-1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black, 1px 1px 0 black",
                    }}
                >
                    One on One
                </h1>
                <h1 style={{ marginTop: "-19px" }}>Individualna edukacija</h1>
                <p>
                    Ova vrsta edukacije je prilagođena vašem trenutnom nivou od
                    početnog do naprednog. Cilj je da vam pruži prijatno
                    primenljivo znanje koje možete odmah primeniti u radu.
                </p>

                <p
                    style={{
                        textAlign: "center",
                        fontSize: "28px",
                        color: "#be9455",
                        letterSpacing: "1px",
                        textShadow:
                            "-1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black, 1px 1px 0 black",
                    }}
                >
                    Šta obuhvata individualna sesija
                </p>
                <p style={{ textAlign: "center" }}>
                    <span
                        style={{
                            color: "#be9455",
                            textShadow:
                                "-1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black, 1px 1px 0 black",
                        }}
                    >
                        *
                    </span>{" "}
                    Ova individualna sesija je namenjena berberima koji žele brz
                    napredak, detaljno razumevanje i potpuno personalizovan
                    pristup
                </p>
                <p style={{ textAlign: "center", marginTop: "-20px" }}>
                    <span
                        style={{
                            color: "#be9455",
                            textShadow:
                                "-1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black, 1px 1px 0 black",
                        }}
                    >
                        *
                    </span>{" "}
                    U jednom danu možemo proći kroz 3 različita šišanja,
                    fokusirajući se na izvođenje (prelaze, oblikovanje, linije,
                    teksturu)
                </p>
                <p style={{ textAlign: "center", marginTop: "-20px" }}>
                    <span
                        style={{
                            color: "#be9455",
                            textShadow:
                                "-1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black, 1px 1px 0 black",
                        }}
                    >
                        *
                    </span>{" "}
                    Korak po korak analizu i izbor alata
                </p>
                <p style={{ textAlign: "center", marginTop: "-20px" }}>
                    <span
                        style={{
                            color: "#be9455",
                            textShadow:
                                "-1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black, 1px 1px 0 black",
                        }}
                    >
                        *
                    </span>{" "}
                    Konačnu fotografiju rezultata (opciono, odlično za izgradnju
                    vašeg portfolija)
                </p>
                <p style={{ textAlign: "center", marginTop: "-20px" }}>
                    <span
                        style={{
                            color: "#be9455",
                            textShadow:
                                "-1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black, 1px 1px 0 black",
                        }}
                    >
                        *
                    </span>{" "}
                    Lični koucing u toku rada, vremenu i oblastima za
                    poboljšanje
                </p>

                <img
                    src={Logo}
                    style={{ width: "140px", borderRadius: "8px" }}
                />

                <p style={{ fontSize: "22px" }}>
                    Obrazovanje je prilagođeno vašem trenutnom nivou znanja - od
                    početnog do naprednog. Cilj je da vam pruži praktično,
                    primenljivo znanje koje možete odmah primeniti.
                </p>

                <p
                    style={{
                        textAlign: "center",
                        marginTop: "10px",
                        marginBottom: "30px",
                    }}
                >
                    <span
                        style={{
                            color: "#be9455",
                            textShadow:
                                "-1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black, 1px 1px 0 black",
                        }}
                    >
                        *
                    </span>{" "}
                    Ova edukacija je idealna za barbere koji žele personalizovan
                    pristup i maksimalan napredak u najkraćem roku
                </p>

                {!loading && (
                    <div
                        style={{
                            textAlign: "center",
                            fontSize: "32px",
                            fontWeight: "bold",
                            color: "#be9455",
                            marginTop: "20px",
                            marginBottom: "10px",
                            textShadow:
                                "-1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black, 1px 1px 0 black",
                        }}
                    >
                        Cena: {price.toLocaleString()} EUR
                    </div>
                )}

                <div
                    className='buy-button-oneonone'
                    onClick={() => {
                        addToCart({
                            id: "one-on-one",
                            name: "One on One",
                            price: price,
                            category: "single",
                        });
                    }}
                >
                    <p>Dodaj u korpu</p>
                </div>
                <p
                    style={{
                        color: "black",
                        textAlign: "center",
                        marginTop: "5px",
                        fontSize: "18px",
                        fontStyle: "italic",
                    }}
                >
                    Datum i vreme ćete izabrati u korpi
                </p>
            </div>

            <a
                className='barbershop-zajednica-footer-title-adresa'
                onClick={HandleOpenMap}
                target='_blank'
                rel='noopener noreferrer'
            >
                <div>
                    <h2>Srpskog sovjeta 1a</h2>
                    <h2>11300, Smederevo</h2>
                    <h2> Klikni me</h2>
                </div>
            </a>
            <div className='barbershop-zajednica-footer-title-adresa'>
                <h2>Posetite Instagram</h2>
                <a
                    href='https://www.instagram.com/_zajednica_/'
                    target='_blank'
                    rel='noopener noreferrer'
                    style={{
                        marginTop: "10px",
                        width: "100%",
                        justifyContent: "center",
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "8px",
                        color: "#f3f3f3",
                        textDecoration: "none",
                    }}
                >
                    <InstagramIcon
                        style={{ color: "#f3f3f3", fontSize: "40px" }}
                    />
                </a>
            </div>

            <div className='barbershop-zajednica-footer-title'>
                <h2>Ili nas kontaktirajte</h2>
            </div>
            <div className='barbershop-zajednica-footer-phone'>
                <a href={`tel:${phoneNumber}`}>{phoneNumber}</a>
            </div>
        </div>
    );
};
